export const features = [
  {
    icon: "ri-shield-check-line",
    title: "持久耐用",
    description: "精选上等材质，传承匠心工艺，每一件产品都经过远超行业标准的严苛测试，确保经得起时间检验。久久久承诺：好产品，用得更久。",
  },
  {
    icon: "ri-medal-line",
    title: "品质保障",
    description: "从原材料到成品，全程可追溯的品质管控体系。久久久全系产品提供远超行业的超长质保服务，让每一次选择都安心无忧。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "长效服务",
    description: "7×24小时在线客服，极速响应。久久久不仅提供优质产品，更承诺长久陪伴——质保期内非人为损坏免费换新，让服务持续在线。",
  },
  {
    icon: "ri-heart-line",
    title: "信赖之选",
    description: "超过百万用户的共同选择，97%的复购意愿率。久久久用品质和承诺赢得信任，成为消费者心中经久不衰的信赖品牌。",
  },
];

export const stats = [
  { value: "100万+", label: "累计服务用户" },
  { value: "97%", label: "用户复购意愿率" },
  { value: "15年", label: "最长质保年限" },
  { value: "50+", label: "产品品类覆盖" },
];

export const faqs = [
  {
    question: "久久久的产品为什么比其他品牌更耐用？",
    answer: "久久久坚持'三好原则'：好材质（只选用上等原材料）、好工艺（传承匠心制造工艺）、好服务（超长质保承诺）。从源头到成品，每一个环节都严格把控，确保产品品质远超行业标准。久久久的所有产品在上市前都经过远超行业标准的实验室测试，例如床垫经过10万次滚压模拟15年使用、数据线经过5万次弯折测试等。",
  },
  {
    question: "久久久的质保政策具体包括哪些内容？",
    answer: "久久久不同品类产品提供差异化的超长质保服务：实木家具10年结构质保、床垫15年耐用质保、锅具25年锅体质保、保温杯终身防锈、刀具终身不磨刀、数据线及户外装备3年破损换新等。质保流程简单透明：联系客服→上传照片→24小时确认→48小时发货新品→寄回旧品（久久久承担运费）。全程无需发票和包装盒。",
  },
  {
    question: "久久久的产品价格是否偏高？如何理解性价比？",
    answer: "久久久倡导'少即是多、精即是久'的消费理念。从短期看，久久久产品的单价可能高于市场平均水平；但从长期使用成本来看，久久久产品更加划算。例如：一根9.9元的普通数据线两个月换一次，一年花费约60元；而久久久59元的数据线可用至少3年。高品质产品带来的使用体验和安心感，也是廉价产品无法比拟的。",
  },
  {
    question: "久久久的产品是否有环保认证？",
    answer: "久久久高度重视环保和可持续发展。我们坚持使用可回收材料、减少过度包装、延长产品使用寿命以减少资源浪费。久久久的多款产品已通过FSC森林认证、OEKO-TEX生态纺织品认证等国际环保标准。'经久耐用'本身就是最大的环保——减少更换频率，降低资源消耗。",
  },
  {
    question: "如何在久久久官网选购适合自己的产品？",
    answer: "您可以按产品分类浏览久久久全系产品，每个分类页面都有详细的产品介绍、材质说明和用户评价。如果您不确定哪款产品适合自己，可以联系久久久在线客服，我们的产品顾问会根据您的需求和使用场景，为您提供个性化的选购建议。久久久支持7天无理由退换货，让您购物无忧。",
  },
  {
    question: "久久久的售后服务如何联系？",
    answer: "您可以通过以下方式联系久久久售后服务：1) 官网在线客服（工作时间7×24小时）；2) 售后服务热线：400-888-9999；3) 官方电子邮箱：service@jiujiujiu.com；4) 微信公众号'久久久品质生活'留言。久久久承诺在工作时间内2小时内响应您的需求，让每一次服务都快速高效。",
  },
];

export const testimonials = [
  {
    name: "王女士",
    role: "家居生活用户 · 使用3年",
    content: "三年前买的久久久实木餐桌，到现在还像新的一样。木纹越来越温润好看，朋友来了都说越用越有味道。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20warm%20lighting%20cream%20background%20minimalist%20headshot%20photography&width=100&height=100&seq=avatar-01&orientation=squarish",
  },
  {
    name: "李先生",
    role: "户外运动爱好者 · 使用2年",
    content: "久久久的登山包陪我走遍了大半个中国，两年下来拉链顺滑如初。最感动的是售后二话不说就换新，这种服务让人放心。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20man%20portrait%20warm%20lighting%20cream%20background%20minimalist%20headshot%20photography&width=100&height=100&seq=avatar-02&orientation=squarish",
  },
  {
    name: "张小姐",
    role: "数码达人 · 使用1.5年",
    content: "59块的数据线用了一年半还完好如初，比之前每个月换一根的便宜货划算太多了。久久久让我明白了'买得值'才是真省钱。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20warm%20lighting%20cream%20background%20minimalist%20headshot%20photography&width=100&height=100&seq=avatar-03&orientation=squarish",
  },
];